import MicroModal from 'micromodal';
import format from 'date-fns/format';

const setActiveDeliveryAddress = () => {
  const activeAddressInput = document.getElementById('AddressId') as HTMLInputElement;
  const activeAddressTypeInput = document.getElementById('AddressType') as HTMLInputElement;
  const newAddress = document.querySelector<HTMLInputElement>(`#address-picker input:checked`);
  const newAddressInternalId = newAddress?.getAttribute('data-address-id');
  const newAddressInternalType = newAddress?.getAttribute('data-address-type');
  const newAddressDomId = newAddress?.id;
  const hasDatePicker = !!document.querySelector('#date-picker');
  if (newAddressInternalId && newAddressInternalType && activeAddressInput && activeAddressTypeInput) {
    activeAddressInput.value = newAddressInternalId;
    activeAddressTypeInput.value = newAddressInternalType;
  }

  if (newAddressDomId && hasDatePicker) {
    try {
      const deliveryDates = document.getElementById(`${newAddressDomId}-delivery-data`);

      if (!deliveryDates) {
        return;
      }
      const deliveryDataJson = deliveryDates.innerHTML ? JSON.parse(deliveryDates.innerHTML) : undefined;

      // Additional delivery info
      const additionalInformationTextArea = document.getElementById('AdditionalInformation') as HTMLTextAreaElement;
      if (additionalInformationTextArea) {
        additionalInformationTextArea.value = '';
      }
      if (additionalInformationTextArea && deliveryDataJson?.DefaultDeliveryInstructions) {
        additionalInformationTextArea.value = deliveryDataJson.DefaultDeliveryInstructions;
      } else if (additionalInformationTextArea) {
        additionalInformationTextArea.value = '';
      }
      //

      const fp = (document.querySelector('#date-picker') as any)._flatpickr;
      const [nextDate] = deliveryDataJson?.availableDeliveryDays;
      if (nextDate) {
        fp.set('minDate', nextDate);
      }

      if (deliveryDataJson?.availableDeliveryDays) {
        fp.set('enable', deliveryDataJson?.availableDeliveryDays);
      }

      const formatDate = nextDate ? format(new Date(nextDate), 'EEEE d MMMM') : undefined;

      const nextAvailableElm = document.querySelector('#nextAvailable + label strong') as HTMLElement;
      const NextDeliveryDate = document.getElementById('#NextDeliveryDate') as HTMLInputElement;
      if (nextAvailableElm && formatDate) {
        nextAvailableElm.innerText = formatDate;
        if (NextDeliveryDate) {
          NextDeliveryDate.value = nextDate;
        }
      }
    } catch (e) {
      console.log(e);
    }
  }
};

const setActiveAddress = () => {
  // Billing of Delivery
  const deliveryAddressInput = document.getElementById('AddressId') as HTMLInputElement;

  if (deliveryAddressInput) {
    setActiveDeliveryAddress();
  } else {
  }
};
(function () {
  // Init the Modal
  MicroModal.init({
    onShow: (modal) => {
      if (modal.id === 'address-picker') {
        setActiveAddress();
      }
    },
    onClose: (modal) => {
      if (modal.id === 'address-picker') {
        setActiveAddress();
      }
    },
    disableScroll: true,
    disableFocus: true,
  });

  const deleteTriggers = document.querySelectorAll('[data-micromodal-delete-trigger]');
  const deleteCloseTriggers = document.querySelectorAll('[data-micromodal-delete-close]');

  if (deleteTriggers && deleteTriggers.length >= 1) {
    deleteTriggers.forEach((deleteTrigger) => {
      deleteTrigger.addEventListener('click', (evt) => {
        const modalId = deleteTrigger.getAttribute('data-micromodal-delete-trigger');

        const modal = document.getElementById(modalId);
        modal.classList.add('show');

        return false;
      });
    });
  }

  if (deleteCloseTriggers && deleteCloseTriggers.length >= 1) {
    deleteCloseTriggers.forEach((deleteCloseTrigger) => {
      deleteCloseTrigger.addEventListener('click', (evt) => {
        const modalId = deleteCloseTrigger.getAttribute('data-micromodal-delete-close');

        const modal = document.getElementById(modalId);
        modal.classList.remove('show');

        return false;
      });
    });
  }

  const toOpen = document.querySelectorAll('.modal.open-on-load');

  if (toOpen && toOpen.length >= 1) {
    toOpen.forEach((modal) => {
      const { id } = modal;

      MicroModal.show(id);
    });
  }
  const formModal = document.querySelector<HTMLFormElement>('form#request-quote');
  const requestQuoteAction = document.querySelector<HTMLButtonElement>('form#request-quote .button[type="submit"]');
  if (formModal && requestQuoteAction) {
    requestQuoteAction.addEventListener('click', (evt) => {
      requestQuoteAction.disabled = true;
      requestQuoteAction.classList.add('is-loading');
      formModal.submit();
      return true;
    });
  }
})();
